var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('Navbar',{attrs:{"certificatePage":true}}),_c('iframe',{attrs:{"src":"https://www.agmep.group/Verify/IAOSHE.html","width":"100%","height":"1200px","frameborder":"0","scrolling":"no"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }